/**
 * @file     breakpoints.ts
 * @readme   ./README.md
 * @purpose  Defines the responsive breakpoint scale (xs through xl) in pixels used across the design system.
 */
import type { BreakpointScale } from '@/core/types';

export const breakpointTokens: BreakpointScale = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
};
